import * as React from "react";
import PageWrapper from "@app/components/PageWrapper";
import { Col, Container, Row } from "react-bootstrap";
import Icon from "@app/components/Icon";
import { useNavigate } from "react-router-dom";
import useOnline from "@app/lib/hooks/useOnline";
import Config from "@app/constants/Config";
import FeedbackForm from "@app/components/FeedbackForm"

export default function ThankYou() {
    const navigate = useNavigate();
    const isOnline = useOnline();

    return (
        <PageWrapper
            buttons={[
                {
                    label: "Zurück zur Übersicht",
					type: "secondary",
                    onClick: () => {
                        navigate(`${Config.BASE_PATH}/`);
                    },
                },
            ]}
            vCenter={true}
            valign={"center"}
        >
            <Container className={"align-self-center"}>
                {!isOnline ? (
                    <Row className={"justify-content-center mb-18"}>
                        <Col xs={"auto"}>
                            <Icon icon={"no-wlan"} size={160} />
                        </Col>
                    </Row>
                ) : (
                    ""
                )}
                <Row className={"justify-content-center"}>
                    <Col sm={10} md={6} lg={5} className={"text-center"}>
                        <h1>Vielen Dank,</h1>
                        {isOnline ? (
                            <p>
                                dass Sie die Tempton Arbeitsplatzbesichtigung ausgefüllt haben. Die Übertragung Ihrer
                                Daten war erfolgreich. Wir melden uns in Kürze bei Ihnen.
                            </p>
                        ) : (
                            <p>
                                dass Sie die Tempton Arbeitsplatzbesichtigung ausgefüllt haben. Die Übertragung Ihrer
                                Daten konnte nicht abgeschlossen werden da keine Verbindung zum Internet besteht.
                                <br />
                                <br />
                                Bitte Übertragen Sie die Daten später manuell.
                            </p>
                        )}
                    </Col>
                </Row>
                <Row className={"mt-30 mb-120"}>
                    <Col>
                        <FeedbackForm variant={"inline"} />
                    </Col>
                </Row>
            </Container>
        </PageWrapper>
    );
}
